import { CreateProfileScreen } from '@/components/CreateProfileScreen';

export default function CreateProfile() {
  return <CreateProfileScreen />;
}
